export type LineUserAccountsResponse = {
	lineUserAccounts: LineUserAccount[];
};
export type LineUserAccount = {
	id: number;
	name: string;
	registered: boolean;
};
export type LineUserAccountEdit = Omit<LineUserAccount, "id" | "registered"> & {
	token?: string;
};
export const buildInitialLineUserAccount = (): LineUserAccountEdit => ({
	name: "",
	token: ""
});
